import { useTranslation } from "react-i18next";

import { generateTranslatedText } from "@/shared/functions/functions";

import { Filter } from "../../../shared";
import RectangleLoader from "../../../shared/components/loaders/RectangleLoader";
import { TAG_COLORS, TAG_SIZES } from "../../Tag/enums";
import Tag from "../../Tag/Tag";

interface IFilteredValueTag {
  isInitialLoading: boolean;
  item: Filter;
  onDelete: (filterItem: Filter) => void;
}

const FilteredValueTag = ({
  isInitialLoading,
  item,
  onDelete
}: IFilteredValueTag) => {
  const { i18n, t } = useTranslation();

  const tagText = generateTranslatedText(item.name, i18n, t);

  return isInitialLoading ? (
    <RectangleLoader
      testId={`${item.name}-rectangle-loader`}
      key={item.name}
      width="77px"
      height={20}
      customStyle={{ padding: "7px 24px 8px 24px" }}
    />
  ) : (
    <Tag
      data-testid={`${item.name}-filter-tag`}
      key={item.name}
      size={TAG_SIZES.Medium}
      color={TAG_COLORS.Primary}
      title={tagText}
      onDelete={() => onDelete(item)}
    />
  );
};

export default FilteredValueTag;
